export default {
  'article.title': 'AllChinaBuy Spreadsheet: Komplet guide til produktfund og kategorier',
  'article.updated': 'Sidst opdateret',
  'article.author': 'Skrevet af AllChinaBuy Spreadsheets redaktionsteam',
  'article.readTime': '8 min læsning',

  'article.quickAnswer.label': 'Hurtigt svar',
  'article.quickAnswer.text': 'AllChinaBuy Spreadsheet er en kurateret samling af produktfund organiseret efter kategori. Det hjælper shoppere med hurtigt at opdage varer inden for sko, tøj, tasker, tilbehør og mere, så du kan sammenligne muligheder og planlægge dine køb ét sted.',

  'article.toc.title': 'På denne side',

  'article.s1.title': 'Hvad er AllChinaBuy Spreadsheet?',
  'article.s1.p1': 'Et AllChinaBuy-spreadsheet er en enkel og organiseret måde at gennemse produktidéer på uden at scrolle gennem endeløse sider. I stedet for at gætte, hvor du skal lede, samler spreadsheetet fund i tydelige kategorier som sko, hættetrøjer, t-shirts, jakker, bukser og tilbehør.',
  'article.s1.p2': 'Tænk på det som et udgangspunkt for produktresearch. Det peger dig mod kategorier og varer, som andre shoppere udforsker, mens den endelige beslutning — og købet — er op til dig. Det er en uafhængig ressource, ikke et officielt værktøj.',

  'article.s2.title': 'Sådan bruger du spreadsheetet til produktresearch',
  'article.s2.p1': 'Du behøver ingen særlige færdigheder for at komme i gang. Grundmetoden er enkel og kan gentages.',
  'article.s2.li1': 'Vælg en kategori — start med den produkttype, du ønsker, f.eks. sko eller tasker.',
  'article.s2.li2': 'Gennemse fundene — kig på varerne under den pågældende kategori.',
  'article.s2.li3': 'Sammenlign muligheder — notér de stilarter, farver og detaljer, der skiller sig ud.',
  'article.s2.li4': 'Besøg hovedwebstedet — følg kategorilinket for at se fulde opslag og foretage et køb.',

  'article.s3.title': 'Forstå produktkategorierne',
  'article.s3.p1': 'Spreadsheetet dækker de mest populære AllChinaBuy-kategorier, så du kan gå direkte til den sektion, der betyder noget for dig.',
  'article.s3.p2': 'Kategorierne omfatter sko, hættetrøjer og sweatshirts, t-shirts, jakker, bukser og shorts, hovedbeklædning, sæt, undertøj, trøjer, tilbehør, tasker, bælter, parfumer og andre diverse varer. Hver kategori linker direkte til den matchende sektion på hovedwebstedet.',

  'article.s4.title': 'Tips til at finde kvalitetsprodukter',
  'article.s4.p1': 'Lidt tålmodighed rækker langt, når du gennemser fund. Her er nogle gode vaner.',
  'article.s4.li1': 'Tjek flere opslag, før du beslutter dig.',
  'article.s4.li2': 'Kig efter tydelige produktbilleder og detaljerede beskrivelser.',
  'article.s4.li3': 'Overvej størrelser og mål nøje, især for tøj og sko.',
  'article.s4.li4': 'Gem interessante fund, så du kan sammenligne dem senere.',

  'article.s5.title': 'En bemærkning om kvalitetskontrol og sælgere',
  'article.s5.p1': 'Kvalitetskontrol og sælgerpålidelighed betyder noget ved ethvert onlinekøb. Gennemgå sælgerfeedback og produktbilleder, når det er muligt, og vær opmærksom på forsendelsesmuligheder og estimerede leveringstider, før du bestiller.',
  'article.s5.p2': 'Husk, at denne ressource er til information og opdagelse. Foretag altid dine egne undersøgelser, og køb fra kilder, du har tillid til.',

  'article.faq.title': 'Ofte stillede spørgsmål',
  'article.faq.q1': 'Er dette et officielt AllChinaBuy-websted?',
  'article.faq.a1': 'Nej. Dette er en uafhængig informationsressource og drives ikke af AllChinaBuy.',
  'article.faq.q2': 'Er AllChinaBuy Spreadsheet gratis at gennemse?',
  'article.faq.a2': 'Ja, kategorilinks og guider her er gratis at udforske. Køb foregår på hovedwebstedet.',
  'article.faq.q3': 'Hvordan finder jeg et bestemt produkt?',
  'article.faq.a3': 'Vælg den nærmeste kategori i dropdownen eller knapperne, og gennemse derefter de linkede opslag på hovedwebstedet.',
  'article.faq.q4': 'Hvor ofte opdateres spreadsheetet?',
  'article.faq.a4': 'Vi sigter mod at holde kategorier og guider aktuelle. Vend regelmæssigt tilbage for de nyeste fund og tips.',

  'article.related.title': 'Relaterede ressourcer',
  'article.related.home': 'Tilbage til AllChinaBuy Spreadsheets forside',

  'article.cta.title': 'Klar til at udforske AllChinaBuy Spreadsheet?',
  'article.cta.subtitle': 'Gennemse kategorier og produktfund, eller gå direkte til hovedwebstedet for at shoppe.',
  'article.cta.button1': 'Udforsk Spreadsheet',
  'article.cta.button2': 'Besøg hovedwebstedet',
  'article.backHome': 'Tilbage til forsiden',
};